module.exports = __webpack_public_path__ + "static/media/om_eyeshape_hooded_hazel.bab5abe5.png";